

import { abibApi, tags, methods } from '.';
import { Sector, SectorGroup, SectorList } from '../types';

type ParentSectorId = number | string;
const apiSector = abibApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllSectors: builder.query<SectorList, any>({
      query: (params) => {
        return {
          method: methods.GET,
          url: `/sectors/simplified`,
        };
      },
      providesTags: (result, error, params) => [tags.sectorList],
      transformResponse: ({ data }, meta, args) => {
        const rawSectors = data as { [key: ParentSectorId]: Sector[] };
        const items = rawSectors[""].map(rootSector => {
          const pair = { rootSector: rootSector } as SectorGroup
          const rootSectorId = (rootSector.id || -1.1)
          if (rootSectorId in rawSectors) {
            pair.subSectors = rawSectors[rootSectorId];
          } else {
            pair.subSectors = [];
          }
          return pair;
        });

        const itemsById = {} as { [key: number]: Sector };
        items.forEach(pair => {
          itemsById[pair.rootSector.id] = pair.rootSector;
          pair.subSectors.forEach(sector => {
            itemsById[sector.id] = sector;
          });
        });

        return {
          items: items,
          itemsById: itemsById
        };
      }
    }),
  }),
  overrideExisting: false,
});


// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllSectorsQuery
} = apiSector;

